










import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryShopBankCardList,DeleteBankCard } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import { BankAccountTypeFormat, BankTypeFormat, PlatformStatusFormat, SourceTypeFormat } from '@/utils/tyepconvert'
import AddBankCardDialog from './components/AddBankCardDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    AddBankCardDialog,
  },
})
export default class BankCodeList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    accountType: 2,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    // { title: '添加银行卡', type: 'primary', click: this.addBankCard },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    // { title: '银行编码', param: 'bankCode' },
    { title: '银行名称', param: 'bankName' },
    { title: '开户名', param: 'accountName' },
    { title: '银行卡号', param: 'accountNo' },
    { title: '银行卡类型', param: 'bankType', formatter: BankTypeFormat },
    { title: '类别', param: 'sourceType', formatter: SourceTypeFormat },
    // { title: '图标', param: 'bankIcon',type:'image' },
    // { title: '是否有效', param: 'enableStatus', formatter: PlatformStatusFormat },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    // {
    //   title: '操作',
    //   width: 150,
    //   operation: [
    //     { title: '解绑', icon: 'el-icon-delete', class: 'red', click: this.deleteRow, show: (data: any)=>{return data.accountType != 3} },
    //   ],
    // },
  ]

  public async created() {
    this.loadData()
  }

  public addBankCard() {
    (this.$refs.AddBankCardDialog as AddBankCardDialog).open()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要解绑吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteBankCard({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryShopBankCardList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
